import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import {
  Typography,
  Button,
  FormControl,
  InputLabel,
  NativeSelect,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material";
import {
  orgClicked,
  transactionDetail,
  showloader,
} from "../store/gloabalState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Cookies from "js-cookie";
import {
  postLeegalityDoc,
  getFilesList,
  getAllPurposes,
} from "../services/httpCalls";
import useNotify from "../utils/useNotify";
import PDFMerger from "pdf-merger-js/browser";
import jsPDF from "jspdf";

export default function PdfProcessor(props) {
  const [authUser, setAuthUser] = useState();
  const [filesList, setFilesList] = useState([]);
  const [filesSelected, setFilesSelected] = useState([]);
  const orgDetails = useRecoilValue(orgClicked);
  const transactionDetails = useRecoilValue(transactionDetail);
  const userInfo = JSON.parse(Cookies.get("userInfo"));
  const [stage, setStage] = useState(0);
  const [blobs, setBlobs] = useState([]);
  const [mergedPdf, setMergedPdf] = useState();
  const [mergedUrl, setMergedUrl] = useState();
  const setShowLoader = useSetRecoilState(showloader);
  const [hidePreviewInvoice, setHidePreviewInvoice] = useState(false);
  const [purposeGroup, setPurposeGroup] = useState();
  const [date, setDate] = useState();
  const [bankName, setBankName] = useState("");
  const [designation, setDesignation] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  let notify = useNotify();

  useEffect(() => {
    const currentDate = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    setDate(
      currentDate.getDate() +
      "-" +
      months[currentDate.getMonth()] +
      "-" +
      currentDate.getFullYear()
    );
    if (!purposeGroup) {
      async function getPurposeList() {
        await getAllPurposes("").then((res) => {
          res?.forEach((elem) => {
            if (
              elem.paymentPurposeCodeAsPerRBI ===
              transactionDetails?.purposeCodeAsPerRBI
            ) {
              setPurposeGroup(elem.paymentPurposeGroupAsPerRBI);
            }
          });
        });
      }
      getPurposeList();
    }
  }, [purposeGroup]);

  useEffect(() => {
    if (
      orgDetails &&
      Object.keys(filesList).length === 0 &&
      transactionDetails
    ) {
      getFilesListFunc();
    }
  }, [filesList.length]);

  async function getFilesListFunc() {
    setShowLoader(true);
    await getFilesList({
      transactionId: transactionDetails.transactionId,
      orgId: orgDetails.id,
      userId: userInfo.id,
    }).then((res) => {
      if (Object.keys(res.files).length) {
        setFilesList(res.files);
        setShowLoader(false);
      } else {
        setShowLoader(false);
      }
    });
  }

  const pdfDownload = () => {
    setShowLoader(true);
    setHidePreviewInvoice(true);
    let pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    pdf.html(document.getElementById("form2pdf"), {
      margin: [25, 25, 25, 25],
      align: "center",
      callback: function () {
        let blobs_ = blobs;
        blobs_.push(pdf.output("blob"));
        setBlobs(blobs_);
        if (filesSelected.length) {
          filesSelected.forEach((elem) => {
            let base64data = filesList[elem];
            toBlobs(base64data);
          });
        }
        if (blobs.length > 1) {
          mergePdf();
        }
      },
    });
  };

  async function mergePdf() {
    const merger = new PDFMerger();
    for (const blob of blobs) {
      await merger.add(blob);
    }
    const mergedPdf_ = await merger.saveAsBlob();
    const url = URL.createObjectURL(mergedPdf_);
    setMergedPdf(mergedPdf_);
    setMergedUrl(url);
    setStage(2);
    setShowLoader(false);
  }

  function finalPreviewSubmit() {
    setShowLoader(true);
    if (mergedPdf) {
      blobToBase64(mergedPdf).then((res) => {
        postData(res);
      });
    }
  }

  function toBlobs(base64data) {
    var base64str = base64data;
    var binary = atob(base64str.replace(/\s/g, ""));
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    var blob = new Blob([view], { type: "application/pdf" });
    let blobs_ = blobs;
    blobs_.push(blob);
    setBlobs(blobs_);
  }

  function postData(base64) {
    let base64_ = base64.replace("data:application/pdf;base64,", "");
    let data = {
      base64File: `${base64_}`,
      organisationId: orgDetails.id,
      signerEmail: authUser.email,
      signerName: authUser.name,
      signerPhone: authUser.phoneNumber,
      transactionId: transactionDetails.transactionId,
      userId: `${userInfo.id}`,
    };
    postLeegalityDoc(data)
      .then((res) => {
        notify.success("Sent Document for esign!");
        setShowLoader(false);
        props.setShowPreview(false);
      })
      .catch((err) => {
        notify.error("Not able to Send Document for esign!");
        setShowLoader(false);
        console.log("err", err);
      });
  }

  function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  function fileSelectionUpdate(e) {
    let filesSelected_ = filesSelected;
    if (filesSelected_.includes(e)) {
      let index_ = filesSelected_.indexOf(e);
      filesSelected_.splice(index_, 1);
    } else {
      filesSelected_.push(e);
    }
    setFilesSelected(filesSelected_);
  }

  function updateStage() {
    setShowLoader(true);
    if (authUser && filesSelected.length) {
      setStage(1);
      setShowLoader(false);
    } else {
      notify.error("Auth User and Min 1 file Selection is must!");
      setShowLoader(false);
    }
  }

  const authUserFunct = (e) => {
    let authUserDetails;
    orgDetails?.userList.forEach((elem) => {
      if (elem.id == e) {
        authUserDetails = elem;
      }
    });
    setAuthUser(authUserDetails);
  };

  return (
    <Box className="modal_wrap">
      <Box className="modal_in">
        <Typography
          className="modal_title"
          variant="h5"
          sx={{
            textAlign: "center",
            color: "#4d4a4a",
            letterSpacing: ".6px",
            marginBottom: 2,
            padding: "1rem 2rem",
            fontWeight: 600,
            borderBottom: "1px solid #ccc7c7",
          }}
        >
          Document Processor - Step {`${stage + 1}`}
        </Typography>
        <Box className="modal_content">
          {stage === 0 && (
            <Box className="userandfileselections" sx={{ padding: "0 1rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl
                    variant="standard"
                    sx={{
                      width: "300px",
                      display: "block",
                      marginTop: ".5rem",
                    }}
                  >
                    <InputLabel htmlFor="authUser">
                      Select Authorised User
                    </InputLabel>
                    <NativeSelect
                      id="authUser"
                      sx={{ padding: ".4rem", width: "100%" }}
                      onChange={(e) => authUserFunct(e.target.value)}
                      value={authUser?.id}
                    >
                      <option value="-">--Select--</option>
                      {orgDetails?.userList &&
                        orgDetails?.userList.map((user, i) => {
                          if (user.isAuthorizer === true) {
                            return (
                              <option value={user.id} key={i}>
                                {user.name}
                              </option>
                            );
                          }
                        })}
                    </NativeSelect>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  {Object.keys(filesList).length ? (
                    <FormGroup>
                      <InputLabel htmlFor="selectFiles">
                        Select Files
                      </InputLabel>
                      {Object.keys(filesList) &&
                        Object.keys(filesList)?.map((file, i) => {
                          return (
                            <FormControlLabel
                              key={i}
                              control={<Checkbox />}
                              label={file}
                              onChange={(e) => fileSelectionUpdate(file)}
                              id={file}
                            />
                          );
                        })}
                    </FormGroup>
                  ) : (
                    <Typography variant="p" sx={{ color: "red" }}>
                      No Files Found !
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
          {stage === 1 && (
            <div className="form2pdf_" id="form2pdf" style={{ width: "550pt" }}>
              <div className="WordSection1">
                <p
                  className="MsoNormal"
                  align="center"
                  style={{
                    marginTop: "3.9pt",
                    marginRight: "172.7pt",
                    marginBottom: ".0001pt",
                    marginLeft: "110.1pt",
                    textAlign: "center",
                  }}
                >
                  {/* <span
                                style={{
                                    position: "absolute",
                                    zIndex: 15728640,
                                    left: 0,
                                    marginLeft: 70,
                                    marginTop: 952,
                                    width: 191,
                                    height: 1
                                }}
                            >
                                <img
                                    width={191}
                                    height={1}
                                    src="SBM%20Form%20for%20Leegality_files/image001.png"
                                />
                            </span> */}
                  <b>
                    <span style={{ fontSize: "8.5pt" }}>
                      FORM<span style={{ letterSpacing: ".65pt" }}> </span>-
                      <span style={{ letterSpacing: ".1pt" }}> </span>A
                      <span style={{ letterSpacing: ".1pt" }}> </span>
                      <span style={{ letterSpacing: ".5pt" }}>2</span>
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  align="center"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "172.7pt",
                    marginBottom: ".0001pt",
                    marginLeft: "110.2pt",
                    textAlign: "center",
                  }}
                >
                  <b>
                    <span style={{ fontSize: "8.5pt" }}>
                      Application
                      <span style={{ letterSpacing: ".7pt" }}> </span>cum
                      <span style={{ letterSpacing: ".5pt" }}> </span>
                      Declaration
                      <span style={{ letterSpacing: ".25pt" }}> </span>
                      <span style={{ letterSpacing: ".2pt" }}>Form</span>
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  align="center"
                  style={{
                    marginTop: "1.5pt",
                    marginRight: "172.7pt",
                    marginBottom: ".0001pt",
                    marginLeft: "130.85pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>
                    (To<span style={{ letterSpacing: ".55pt" }}> </span>be
                    <span style={{ letterSpacing: ".15pt" }}> </span>completed
                    <span style={{ letterSpacing: ".1pt" }}> </span>by
                    <span style={{ letterSpacing: ".1pt" }}> </span>the
                    <span style={{ letterSpacing: ".1pt" }}> applicant)</span>
                  </span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".4pt",
                    marginRight: "0in",
                    marginBottom: ".05pt",
                    marginLeft: "0in",
                  }}
                >
                  <span style={{ fontSize: "6.0pt" }}>&nbsp;</span>
                </p>
                <table
                  className="MsoNormalTable"
                  border={0}
                  cellSpacing={0}
                  cellPadding={0}
                  style={{ marginLeft: "5.85pt", borderCollapse: "collapse" }}
                >
                  <tbody>
                    <tr style={{ height: "127.4pt" }}>
                      <td
                        width={180}
                        valign="top"
                        style={{
                          width: "180.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "127.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "8.1pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "2.5pt",
                          }}
                        >
                          <b>
                            <span style={{ fontSize: "8.5pt" }}>
                              FORM
                              <span style={{ letterSpacing: ".25pt" }}>
                                {" "}
                                A2
                              </span>
                            </span>
                          </b>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{ marginTop: ".55pt" }}
                        >
                          <span style={{ fontSize: "10.0pt" }}>&nbsp;</span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{ marginLeft: "2.5pt" }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            (For
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            payments
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            other
                            <span style={{ letterSpacing: ".35pt" }}></span>
                            than
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            imports
                            <span style={{ letterSpacing: ".3pt" }}> </span>and
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            remittances covering intermediary trade)
                          </span>
                        </p>
                        <p className="TableParagraph">
                          <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "2.5pt",
                          }}
                        >
                          <b>
                            <u>
                              <span style={{ fontSize: "8.5pt" }}>
                                Application
                                <span style={{ letterSpacing: ".4pt" }}>
                                  {" "}
                                </span>
                                for
                                <span style={{ letterSpacing: ".35pt" }}>
                                  {" "}
                                </span>
                                Remittance
                                <span style={{ letterSpacing: ".35pt" }}>
                                  {" "}
                                </span>
                                <span style={{ letterSpacing: ".1pt" }}>
                                  Abroad
                                </span>
                              </span>
                            </u>
                          </b>
                        </p>
                      </td>
                      <td
                        width={50}
                        valign="top"
                        style={{
                          width: "200.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "127.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "0in",
                            marginRight: "61.0pt",
                            marginBottom: ".0001pt",
                            marginLeft: "10.55pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            <p
                              className="MsoNormal"
                              style={{ marginBottom: 0 }}
                            >
                              AD Code No. ______________________
                            </p>
                            <p
                              className="MsoNormal"
                              style={{ marginBottom: 0 }}
                            >
                              Form No. ______________________
                            </p>
                            (To be filled in by the Authorised Dealer)
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "0in",
                            marginRight: "62.0pt",
                            marginBottom: ".0001pt",
                            marginLeft: "10.55pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            <p
                              className="MsoNormal"
                              style={{ marginBottom: 0 }}
                            >
                              Serial No. ______________________
                            </p>
                            (For use of Reserve Bank of India)
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "0in",
                            marginRight: "57.3pt",
                            marginBottom: ".0001pt",
                            marginLeft: "10.55pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            <p
                              className="MsoNormal"
                              style={{ marginBottom: 0 }}
                            >
                              Currency {transactionDetails?.currencyCode ? " " + transactionDetails?.currencyCode + " " : " _______________ "}
                              Amount {transactionDetails?.netPayableAmount ? " " + transactionDetails?.netPayableAmount + " " : " _______________ "} <br />
                              Equivalent to Rs. _______________
                            </p>
                            (To be completed by Authorised Dealer)
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "300.9pt" }}>
                      <td
                        width={660}
                        colSpan={2}
                        valign="top"
                        style={{
                          width: "495.1pt",
                          padding: "0in 0in 0in 0in",
                          height: "300.9pt",
                        }}
                      >
                        <p className="TableParagraph">&nbsp;</p>
                        <p
                          className="TableParagraph"
                          style={{ marginLeft: "2.5pt", width: "410pt" }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            I/We
                            <span style={{ letterSpacing: ".15pt" }}> </span>
                            <a>
                              {orgDetails?.name}
                              <span style={{ letterSpacing: ".1pt" }}>
                                &nbsp;
                              </span>
                            </a>
                          </span>
                          <span style={{ fontSize: "8.5pt", letterSpacing:'.4pt' }}>
                            (PAN :
                            <span style={{ letterSpacing: ".5pt" }}> </span>
                            {orgDetails?.panNumber + "  "} {" "})
                          </span>
                              {" "}
                          <span style={{ fontSize: "8.5pt", letterSpacing:'.4pt' }}>
                            CIF : {orgDetails.adBankDetailList[0].customerId ? orgDetails.adBankDetailList[0].customerId : orgDetails.bankDetailList[0].customerId}
                            <span style={{ letterSpacing: ".15pt" }}> </span>
                            authorize
                            <span style={{ letterSpacing: ".1pt" }}> </span>SBM
                            <span style={{ letterSpacing: ".1pt" }}> </span>
                            Bank
                            <span style={{ letterSpacing: ".1pt" }}> </span>
                            India
                            <span style={{ letterSpacing: ".1pt" }}></span> to
                            <span style={{ letterSpacing: ".25pt" }}> </span>
                            debit <a />
                            <a>
                              Digital Trade - collection account- 27615048182650{" "}
                            </a>
                          </span>
                          <span style={{ fontSize: "8.5pt" }}>
                            together with their charges and
                          </span>
                        </p>
                        <p className="TableParagraph">
                          <span style={{ fontSize: "8.5pt" }}>
                            Effect
                            <span style={{ letterSpacing: ".3pt" }}> </span>the
                            <span style={{ letterSpacing: ".4pt" }}> </span>
                            foreign
                            <span style={{ letterSpacing: ".4pt" }}> </span>
                            <a>
                              exchange
                              <span style={{ letterSpacing: ".25pt" }}> </span>
                              remittance
                              <span style={{ letterSpacing: ".25pt" }}> </span>
                              directly
                              <span style={{ letterSpacing: ".25pt" }}> </span>
                            </a>
                          </span>
                          <span
                            style={{
                              fontSize: "8.5pt",
                              letterSpacing: ".5pt",
                            }}
                          >
                            –
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".05pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "39.9pt",
                            textIndent: "-13.45pt",
                            lineHeight: "12.05pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            1)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;&nbsp;
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt", letterSpacing: ".55pt" }}>
                            Beneficiary's
                            <span style={{ letterSpacing: ".45pt" }}> </span>
                            Name :
                            <span style={{ letterSpacing: ".55pt" }}></span>
                            {" " + transactionDetails?.vendorName}
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginLeft: "40.5pt",
                            textIndent: "-14.05pt",
                            lineHeight: "12.05pt",
                            marginBottom: "0",
                            marginRight: "100.55pt"
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            2)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;&nbsp;&nbsp;
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt" }}>
                            Name
                            <span style={{ letterSpacing: ".4pt" }}> </span>and
                            <span style={{ letterSpacing: ".25pt" }}> </span>
                            address
                            <span style={{ letterSpacing: ".15pt" }}> </span>of
                            <span style={{ letterSpacing: ".2pt" }}> </span>the
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            bank :
                            <span
                              style={{ letterSpacing: ".5pt", wordBreak: 'break-all' }}
                            >
                              {" "}
                              {transactionDetails?.vendorBankName
                                + " " +
                                ", " +
                                transactionDetails?.vendorBankAddress}
                            </span>
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "39.9pt",
                            textIndent: "-13.45pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            3)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;&nbsp;
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt" }}>
                            Account
                            <span style={{ letterSpacing: ".25pt" }}> </span>
                            No. :
                            <span style={{ letterSpacing: ".4pt" }}>
                              {" "}
                              {transactionDetails?.vendorAccountNumber}
                              <span style={{ letterSpacing: ".15pt" }}> </span>
                              {/* &lt;&lt;Vendor account number&gt;&gt; */}
                            </span>
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".05pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "37.9pt",
                            textIndent: "-11.45pt",
                            lineHeight: "12.05pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            4)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;{" "}
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            SWIFT
                            <span style={{ letterSpacing: ".2pt" }}></span> Code
                            :<span style={{ letterSpacing: ".3pt" }}> </span>
                          </span>
                          <span
                            style={{
                              fontSize: "8.5pt",
                              letterSpacing: ".6pt",
                            }}
                          >
                            {/* &lt;&lt;SWIFT CODE OR IBAN whichever is available&gt;&gt; */}
                            {transactionDetails?.vendorSwiftCode
                              ? transactionDetails?.vendorSwiftCode
                              : transactionDetails?.vendorIbanCode}
                              <span style={{ letterSpacing: ".15pt" }}> </span>
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginLeft: "37.9pt",
                            textIndent: "-11.45pt",
                            lineHeight: "12.05pt",
                            marginBottom: "0"
                          }}
                        >
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            5)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;{" "}
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            Amount :
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            {/* &lt;&lt;Currency&gt;&gt; &lt;&lt;Amount&gt;&gt; */}
                            {transactionDetails?.currencyCode +
                              " " +
                              transactionDetails?.netPayableAmount}
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginLeft: "37.9pt",
                            textIndent: "-11.45pt",
                            lineHeight: "12.05pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            6)
                            <span style={{ font: '7.0pt "Times New Roman"' }}>
                              &nbsp;{" "}
                            </span>
                          </span>
                          <span style={{ fontSize: "8.5pt", color: "#212121" }}>
                            Bank transaction charges :
                            <span style={{ letterSpacing: ".3pt" }}> </span>
                            {/* &lt;&lt;Currency&gt;&gt; &lt;&lt;Amount&gt;&gt; */}
                            OUR
                          </span>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{ marginTop: ".05pt" }}
                        >
                          <span style={{ fontSize: "12.0pt" }}>&nbsp;</span>
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "60.8pt" }}>
                      <td
                        width={660}
                        colSpan={2}
                        valign="top"
                        style={{
                          width: "495.1pt",
                          padding: "0in 0in 0in 0in",
                          height: "60.8pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "9.9pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "2.5pt",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "8.5pt",
                              letterSpacing: ".4pt",
                            }}
                          >
                            Signature
                          </span>
                        </p>

                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".05pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "2.5pt",
                            lineHeight: "11.1pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            Name
                            <span style={{ letterSpacing: "1.4pt" }}> </span>:
                            <span style={{ letterSpacing: ".25pt" }}> </span>
                          </span>
                          <b>
                            <span
                              style={{
                                fontSize: "9.5pt",
                                fontFamily: '"Trebuchet MS",sans-serif',
                              }}
                            >
                              <span style={{ letterSpacing: ".5pt" }}>
                                {authUser.name && authUser.name}
                              </span>
                            </span>
                          </b>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".05pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "300pt",
                          }}
                        >
                          <span style={{ fontSize: "8.5pt" }}>
                            Date
                            <span style={{ letterSpacing: "1.5pt" }}> </span>:
                            <span style={{ letterSpacing: ".15pt" }}> </span>
                            {date}
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span
                style={{
                  fontSize: "9.5pt",
                  fontFamily: '"Trebuchet MS",sans-serif',
                }}
              >
                <br clear="all" style={{ pageBreakBefore: "always" }} />
              </span>
              <p className="TableParagraph" style={{ marginRight: "316.7pt" }}>
                <span style={{ fontSize: "8.5pt" }}>
                  for the purpose indicated below
                </span>
              </p>
              <div className="WordSection2" style={{ width: "410pt" }}>
                <table
                  className="MsoNormalTable"
                  border={1}
                  cellSpacing={0}
                  cellPadding={0}
                  style={{
                    marginLeft: "12.5pt",
                    borderCollapse: "collapse",
                    border: "none",
                    width: "400pt",
                  }}
                >
                  <tbody>
                    <tr style={{ height: "43.4pt" }}>
                      <td
                        width={48}
                        valign="top"
                        style={{
                          width: ".5in",
                          border: "solid black 1.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "43.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".85pt",
                            marginRight: "0in",
                            marginBottom: ".0001pt",
                            marginLeft: "5.9pt",
                            lineHeight: "12.05pt",
                          }}
                        >
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".35pt",
                              }}
                            >
                              Sr.
                            </span>
                          </b>
                        </p>
                        <p
                          className="TableParagraph"
                          style={{
                            marginLeft: "5.35pt",
                            lineHeight: "12.05pt",
                          }}
                        >
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".25pt",
                              }}
                            >
                              No.
                            </span>
                          </b>
                        </p>
                      </td>
                      <td
                        width={96}
                        valign="top"
                        style={{
                          width: "71.9pt",
                          border: "solid black 1.0pt",
                          borderLeft: "none",
                          padding: "0in 0in 0in 0in",
                          height: "43.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          align="center"
                          style={{
                            marginTop: ".85pt",
                            marginRight: "16.4pt",
                            marginBottom: ".0001pt",
                            marginLeft: "17.45pt",
                            textAlign: "center",
                          }}
                        >
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".5pt",
                              }}
                            >
                              Purpose {" "}
                            </span>
                          </b>
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".2pt",
                              }}
                            >
                              Group Name
                            </span>
                          </b>
                        </p>
                      </td>
                      <td
                        width={91}
                        valign="top"
                        style={{
                          width: "68.15pt",
                          border: "solid black 1.0pt",
                          borderLeft: "none",
                          padding: "0in 0in 0in 0in",
                          height: "43.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: ".85pt",
                            marginRight: "10pt",
                            marginBottom: ".0001pt",
                            marginLeft: "12.4pt",
                            textIndent: "-6.75pt",
                          }}
                        >
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".5pt",
                              }}
                            >
                              Purpose{" "}
                            </span>
                          </b>
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".2pt",
                              }}
                            >
                              Code
                            </span>
                          </b>
                        </p>
                      </td>
                      <td
                        width={365}
                        valign="top"
                        style={{
                          width: "274.0pt",
                          border: "solid black 1.0pt",
                          borderLeft: "none",
                          padding: "0in 0in 0in 0in",
                          height: "43.4pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          align="center"
                          style={{
                            marginTop: "2.85pt",
                            marginRight: "50.55pt",
                            marginBottom: ".0001pt",
                            marginLeft: "50.6pt",
                            textAlign: "center",
                          }}
                        >
                          <b>
                            <span
                              style={{
                                fontSize: "7.5pt",
                                letterSpacing: ".5pt",
                              }}
                            >
                              Description
                            </span>
                          </b>
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "64.95pt" }}>
                      <td
                        width={48}
                        valign="top"
                        style={{
                          width: ".5in",
                          border: "solid black 1.0pt",
                          borderTop: "none",
                          padding: "0in 0in 0in 0in",
                          height: "64.95pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{ marginLeft: "3.2pt" }}
                        >
                          <b>
                            <span style={{ fontSize: "7.5pt" }}>1</span>
                          </b>
                        </p>
                      </td>
                      <td
                        width={96}
                        valign="top"
                        style={{
                          width: "71.9pt",
                          borderTop: "none",
                          borderLeft: "none",
                          borderBottom: "solid black 1.0pt",
                          borderRight: "solid black 1.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "64.95pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{
                            marginTop: "1.2pt",
                            marginRight: "6.25pt",
                            marginBottom: ".0001pt",
                            marginLeft: "5.7pt",
                            lineHeight: "113%",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "7.5pt",
                              lineHeight: "113%",
                              letterSpacing: ".5pt",
                            }}
                          >
                            {purposeGroup}
                          </span>
                        </p>
                      </td>
                      <td
                        width={91}
                        valign="top"
                        style={{
                          width: "68.15pt",
                          borderTop: "none",
                          borderLeft: "none",
                          borderBottom: "solid black 1.0pt",
                          borderRight: "solid black 1.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "64.95pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{ marginLeft: "3.1pt" }}
                        >
                          <span
                            style={{
                              fontSize: "7.5pt",
                              letterSpacing: ".7pt",
                            }}
                          >
                            {/* &lt;&lt;as per purpose code mapping&gt;&gt; */}
                            {transactionDetails?.purposeCodeAsPerRBI}
                          </span>
                        </p>
                      </td>
                      <td
                        width={365}
                        valign="top"
                        style={{
                          width: "274.0pt",
                          borderTop: "none",
                          borderLeft: "none",
                          borderBottom: "solid black 1.0pt",
                          borderRight: "solid black 1.0pt",
                          padding: "0in 0in 0in 0in",
                          height: "64.95pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          style={{ marginLeft: "5.75pt" }}
                        >
                          <span
                            style={{
                              fontSize: "7.5pt",
                              letterSpacing: ".5pt",
                            }}
                          >
                            {/* &lt;&lt;as per purpose code mapping&gt;&gt; */}
                            {transactionDetails?.purposeDescriptionAsPerRBI}
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "27.3pt" }}>
                      <td
                        width={600}
                        colSpan={4}
                        valign="top"
                        style={{
                          width: "450.05pt",
                          border: "solid black 1.0pt",
                          borderTop: "none",
                          padding: "0in 0in 0in 0in",
                          height: "27.3pt",
                        }}
                      >
                        <p
                          className="TableParagraph"
                          align="center"
                          style={{
                            marginTop: ".85pt",
                            // marginRight: "184.7pt",
                            marginBottom: ".0001pt",
                            // marginLeft: "100.9pt",
                            textAlign: "center",
                          }}
                        >
                          <b>
                            <span style={{ fontSize: "7.5pt" }}>
                              As
                              <span style={{ letterSpacing: ".7pt" }}> </span>
                              per
                              <span style={{ letterSpacing: ".05pt" }}> </span>
                              the
                              <span style={{ letterSpacing: ".2pt" }}> </span>
                              <span style={{ letterSpacing: ".1pt" }}>
                                Annex
                              </span>
                            </span>
                          </b>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="MsoNormal">
                  <span style={{ fontSize: "10.0pt" }}>&nbsp;</span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: "4.6pt",
                    marginRight: "100.2pt",
                    marginBottom: ".0001pt",
                    marginLeft: "100.9pt",
                    textIndent: "19.9pt",
                    lineHeight: "111%",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "8.5pt",
                        lineHeight: "111%",
                        letterSpacing: ".1pt",
                      }}
                    >
                      Declaration
                    </span>
                  </b>
                  <b>
                    <span style={{ fontSize: "8.5pt", lineHeight: "111%" }}>
                      (Under<span style={{ letterSpacing: ".65pt" }}> </span>
                      FEMA
                      <span style={{ letterSpacing: ".3pt" }}> </span>
                      <span style={{ letterSpacing: ".1pt" }}>1999)</span>
                    </span>
                  </b>
                </p>
                <p className="MsoNormal" style={{ marginTop: ".4pt" }}>
                  <b>
                    <span style={{ fontSize: "11.5pt" }}>&nbsp;</span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{ marginLeft: "14.0pt", lineHeight: "12.55pt" }}
                >
                  <span style={{ fontSize: "8.5pt" }}>
                    I,<span style={{ letterSpacing: ".35pt" }}> </span>
                    <span style={{ position: "relative", top: ".5pt" }}>
                      {/* &lt;&lt;Name of the company&gt;&gt; */}
                      {orgDetails?.name}
                      <span style={{ letterSpacing: ".2pt" }}> </span>
                    </span>
                    declare<span style={{ letterSpacing: ".65pt" }}> </span>
                    that
                    <span style={{ letterSpacing: ".25pt" }}> </span>
                    <span style={{ letterSpacing: ".5pt" }}>–</span>
                  </span>
                </p>
                <p
                  className="MsoNormal"
                  style={{ marginLeft: "59.7pt", lineHeight: "12.05pt" }}
                >
                  <span style={{ fontSize: "8.5pt", letterSpacing: ".5pt" }}>
                    -
                  </span>
                  <span style={{ fontSize: "8.5pt" }}>
                    &nbsp;&nbsp;&nbsp; Foreign
                    <span style={{ letterSpacing: ".3pt" }}> </span>exchange
                    <span style={{ letterSpacing: ".15pt" }}> </span>purchased
                    <span style={{ letterSpacing: ".35pt" }}> </span>from
                    <span style={{ letterSpacing: ".35pt" }}> </span>you
                    <span style={{ letterSpacing: ".15pt" }}> </span>is
                    <span style={{ letterSpacing: ".2pt" }}> </span>for
                    <span style={{ letterSpacing: ".2pt" }}> </span>the
                    <span style={{ letterSpacing: ".2pt" }}> </span>purpose
                    <span style={{ letterSpacing: ".2pt" }}> </span>indicated
                    <span style={{ letterSpacing: ".15pt" }}></span>
                    <span style={{ letterSpacing: ".1pt" }}>above.</span>
                  </span>
                </p>
                <p className="MsoNormal">&nbsp;</p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="TableParagraph"
                  style={{
                    marginTop: ".05pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "2.5pt",
                  }}
                >
                  <span style={{ fontSize: "8.5pt" }}>&nbsp;</span>
                </p>
                <p
                  className="MsoBodyText"
                  style={{ marginTop: ".4pt", marginLeft: "300pt" }}
                >
                  <span
                    style={{
                      fontSize: "8.5pt",
                      fontFamily: '"Times New Roman",serif',
                    }}
                  >
                    Date : {date}
                  </span>
                </p>
                <p
                  className="MsoBodyText"
                  style={{ marginTop: ".4pt", marginLeft: "2.5pt" }}
                >
                  <span
                    style={{
                      fontSize: "8.5pt",
                      fontFamily: '"Times New Roman",serif',
                    }}
                  >
                    Signature
                  </span>
                </p>
                <p
                  className="MsoBodyText"
                  style={{ marginTop: ".4pt", marginLeft: "2.5pt" }}
                >
                  <span
                    style={{
                      fontSize: "8.5pt",
                      fontFamily: '"Times New Roman",serif',
                    }}
                  >
                    Name : {authUser.name}
                  </span>
                </p>
              </div>
              <span
                style={{
                  fontSize: "8.5pt",
                  fontFamily: '"Times New Roman",serif',
                }}
              >
                <br clear="all" style={{ pageBreakBefore: "always" }} />
              </span>
              <div
                className="WordSection3"
                style={{ maxWidth: "75%", fontSize: "8.5pt" }}
              >
                <p
                  className="MsoBodyText"
                  style={{
                    marginTop: "1.65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <span style={{ letterSpacing: ".25pt" }}>To,</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  <span style={{ letterSpacing: ".1pt" }}>Date:</span>
                  <span style={{ letterSpacing: ".3pt" }}> </span>
                  <span style={{ letterSpacing: ".1pt" }}>{date}</span>
                </p>
                <p
                  className="MsoBodyText"
                  style={{
                    marginTop: ".8pt",
                    marginRight: "318.7pt",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                    lineHeight: "105%",
                  }}
                >
                  SBM<span style={{ letterSpacing: ".8pt" }}> </span>Bank
                  <span style={{ letterSpacing: ".75pt" }}> </span>India
                  <span style={{ letterSpacing: ".75pt" }}> </span>Ltd,{" "}
                  <span style={{ letterSpacing: ".3pt" }}>Nariman</span>
                  <span style={{ letterSpacing: ".6pt" }}> </span>
                  <span style={{ letterSpacing: ".3pt" }}>Point, Mumbai</span>
                </p>
                <p className="MsoBodyText">&nbsp;</p>
                <p className="MsoNormal" style={{ marginLeft: "5.0pt" }}>
                  <b>
                    <span
                      style={{
                        fontSize: "8.5pt",
                        fontFamily: '"Arial",sans-serif',
                        color: "#232323",
                      }}
                    >
                      The<span style={{ letterSpacing: ".5pt" }}> </span>
                      declaration-cum-undertaking
                      <span style={{ letterSpacing: ".45pt" }}> </span>under
                      <span style={{ letterSpacing: ".45pt" }}> </span>Sec
                      <span style={{ letterSpacing: ".5pt" }}> </span>10(5),
                      <span style={{ letterSpacing: ".5pt" }}> </span>Chapter
                      <span style={{ letterSpacing: ".45pt" }}></span>III
                      <span style={{ letterSpacing: ".55pt" }}> </span>of
                      <span style={{ letterSpacing: ".5pt" }}> </span>FEMA,
                      <span style={{ letterSpacing: ".55pt" }}> </span>
                      <span style={{ letterSpacing: ".2pt" }}>1999</span>
                    </span>
                  </b>
                </p>
                <p className="MsoBodyText">
                  <b>
                    <span style={{ fontSize: "5.5pt" }}>&nbsp;</span>
                  </b>
                </p>
                <p
                  className="MsoBodyText"
                  style={{
                    marginTop: "0in",
                    marginRight: "5.8pt",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                    lineHeight: "115%",
                  }}
                >
                  <span style={{ color: "#232323" }}>
                    I/We hereby declare that the transaction details of which
                    are mentioned above does not involve, and is not designed
                    for the purpose of any contravention or evasion of the
                    provisions of the aforesaid Act or of any rule, regulation,
                    notification, direction or order
                    <span style={{ letterSpacing: "4.0pt" }}> </span>made
                    thereunder. I/We also hereby agree and undertake to give
                    such information / documents as will reasonably satisfy you
                    about this transaction in terms of the above declaration.
                    I/We also undertake that if I/we refuse to comply with any
                    such requirement or make
                    <span style={{ letterSpacing: ".05pt" }}> </span>only
                    unsatisfactory
                    <span style={{ letterSpacing: ".1pt" }}> </span>compliance
                    <span style={{ letterSpacing: ".1pt" }}> </span>therewith,
                    <span style={{ letterSpacing: ".05pt" }}> </span>the
                    <span style={{ letterSpacing: ".1pt" }}> </span>Bank shall
                    <span style={{ letterSpacing: ".1pt" }}> </span>refuse
                    <span style={{ letterSpacing: ".05pt" }}></span>in
                    <span style={{ letterSpacing: ".1pt" }}> </span>writing
                    <span style={{ letterSpacing: ".1pt" }}> </span>to
                    <span style={{ letterSpacing: ".1pt" }}> </span>undertake
                    the transaction and shall if it has reason to believe that
                    any contravention /
                    <span style={{ letterSpacing: ".05pt" }}> </span>evasion is
                    contemplated by me /
                    <span style={{ letterSpacing: ".1pt" }}> </span>us report
                    the matter to RBI. I/We further declare that the undersigned
                    has the authority to give this application, declaration and
                    undertaking on behalf of the{" "}
                    <span style={{ letterSpacing: ".1pt" }}>
                      firm/company.
                    </span>
                  </span>
                </p>
                <p className="MsoBodyText">
                  <span style={{ fontSize: "10.0pt" }}>&nbsp;</span>
                </p>

                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "9.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </b>
                </p>
                <p
                  className="MsoBodyText"
                  style={{
                    marginTop: "8.9pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  Thanks &amp;<span style={{ letterSpacing: ".95pt" }}> </span>
                  <span style={{ letterSpacing: ".5pt" }}>Regards,</span>
                </p>
                <p className="MsoBodyText" style={{ marginLeft: "5.0pt" }}>
                  Authorised<span style={{ letterSpacing: "1.25pt" }}> </span>
                  <span style={{ letterSpacing: ".3pt" }}>Signatory</span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: ".65pt",
                    marginRight: "0in",
                    marginBottom: ".0001pt",
                    marginLeft: "5.0pt",
                  }}
                >
                  <b>
                    <span
                      style={{
                        fontSize: "8.5pt",
                        fontFamily: '"Trebuchet MS",sans-serif',
                      }}
                    >
                      {authUser.name}
                    </span>
                  </b>
                </p>
              </div>
              {!hidePreviewInvoice && (
                <div className="Preview_invoices" style={{ width: "450pt" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      padding: "1rem",
                      textAlign: "center",
                      fontWeight: "600",
                      fontSize: "9pt",
                    }}
                  >
                    Preview Invoices
                  </Typography>
                  {filesSelected.length
                    ? filesSelected.map((file, i) => {
                      let pdfView = filesList[file];
                      return (
                        <Box sx={{ padding: "1rem" }} key={i}>
                          <Typography
                            variant="h6"
                            sx={{ paddingBottom: ".5rem", fontSize: "8pt" }}
                          >
                            {file}
                          </Typography>
                          <embed
                            src={`data:application/pdf;base64,${pdfView}`}
                          />
                        </Box>
                      );
                    })
                    : ""}
                </div>
              )}
            </div>
          )}
          {stage === 2 && mergedUrl && (
            <Box className="finalPreview" sx={{ padding: "0 1rem" }}>
              {<embed src={mergedUrl} width="100%" height="900px" />}
            </Box>
          )}
        </Box>
        <Box
          className="modal_footer"
          sx={{ padding: "1rem 0", textAlign: "right" }}
        >
          <Button
            variant="outlined"
            onClick={(e) => props.setShowPreview(false)}
            sx={{
              marginRight: "1rem",
              border: "1px solid #dc1d00",
              color: "#dc1d00",
            }}
          >
            Cancel
          </Button>
          {stage === 0 && (
            <Button
              variant="contained"
              onClick={updateStage}
              disabled={Object.keys(filesList).length === 0 ? true : false}
              sx={{ backgroundColor: "#dc1d00" }}
            >
              Proceed
            </Button>
          )}
          {stage === 1 && (
            <Button
              variant="contained"
              onClick={pdfDownload}
              sx={{ backgroundColor: "#dc1d00" }}
            >
              Convert Document
            </Button>
          )}
          {stage === 2 && (
            <Button
              variant="contained"
              onClick={finalPreviewSubmit}
              sx={{ backgroundColor: "#dc1d00" }}
            >
              Submit
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
